import React from "react";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";

import { Menu, MenuItem, Popover } from "@blueprintjs/core";

const ProductActions = (props) => {
  const optionsMenu = (
    <Menu>
      {props.product.status === "active" ? (
        <MenuItem
          onClick={() =>
            props.onEditClicked ? props.onEditClicked(props.product) : undefined
          }
          text="Manage"
        />
      ) : (
        <React.Fragment></React.Fragment>
      )}

      {/* {props.no > 0 ? ( */}
      {1 == 1 ? (
        <React.Fragment>
          <MenuItem
            onClick={() =>
              props.onEditClicked
                ? props.getProxyListBySubnet(props.product)
                : undefined
            }
            text="Proxies List by Subnet"
          />
          <MenuItem
            onClick={() =>
              props.onEditClicked
                ? props.getProxyList(props.product)
                : undefined
            }
            text="Proxies List"
          />
          <MenuItem
            onClick={() =>
              props.onEditClicked
                ? props.refreshProxyListBySubnet(props.product)
                : undefined
            }
            text="Refresh Proxies List"
          />
        </React.Fragment>
      ) : (
        <React.Fragment></React.Fragment>
      )}

      {props.product.status === "inactive" ? (
        <MenuItem
          onClick={() =>
            props.onEditClicked ? props.repurchase(props.product) : undefined
          }
          text="Repurchase"
        />
      ) : (
        <React.Fragment></React.Fragment>
      )}
      {props.product.status === "active" ? (
        <MenuItem
          onClick={() =>
            props.onTerminateClick
              ? props.onTerminateClick(props.product)
              : undefined
          }
          text="Terminate"
        />
      ) : (
        <React.Fragment></React.Fragment>
      )}

      {props.product.status === "refresh_pending" ? (
        <React.Fragment>
          <MenuItem
            onClick={() =>
              props.approveRefresh
                ? props.approveRefresh(props.product)
                : undefined
            }
            text="Approve Refresh"
          />
          <MenuItem
            onClick={() =>
              props.rejectRefresh
                ? props.rejectRefresh(props.product)
                : undefined
            }
            text="Reject Refresh"
          />
        </React.Fragment>
      ) : (
        <React.Fragment></React.Fragment>
      )}

      {props.product.status === "terminate_pending" ? (
        <React.Fragment>
          <MenuItem
            onClick={() =>
              props.approveTerminate
                ? props.approveTerminate(props.product)
                : undefined
            }
            text="Approve Terminate"
          />
          <MenuItem
            onClick={() =>
              props.rejectTerminate
                ? props.rejectTerminate(props.product)
                : undefined
            }
            text="Reject Terminate"
          />
        </React.Fragment>
      ) : (
        <React.Fragment></React.Fragment>
      )}
    </Menu>
  );
  return (
    <div>
      <div className="more-details-ellipsis-container">
        <Popover content={optionsMenu} position="bottom">
          <DotsHorizontalIcon />
        </Popover>
      </div>
    </div>
  );
};

export default ProductActions;
